import React, { useEffect, useState } from "react";
import { withUser } from "@coverme/identity";
import { Birdseed } from "@coverme/elements";
import { connect } from "react-redux";
import * as retrocheckActions from "../../actions/retrocheckActions";
import * as casesActions from "../../actions/casesActions";
import "../../components/Retrocheck/Retrocheck.scss";
import { LoadingBar } from "../../components/LoadingComponents/LoadingBar";
import { postAndDownloadFile } from "../../services/fileDownloader";
import { Link } from "react-router-dom";
import { DocumentForm } from "../../components/FormComponents/DocumentForm";
import * as retrocheckService from "../../services/retrocheckService";
import { DashboardBanner } from "../../components/DashboardBanner/DashboardBanner";
import { CTA } from "@coverme/forms";
import { toast } from "react-toastify";
import { MyCasesTable } from "../../components/MyCasesTable/MyCasesTable";
import { useFilters } from "../../hooks/useFilters";
import { RetrocheckTable } from "../../components/Retrocheck/RetrocheckTable";
import { RetrocheckFilters } from "../../components/Retrocheck/RetrocheckFilters";

export const RetrocheckComponent = ({ user, history, getFiles, customerId, files, updateRetrocheckFilter }) => {
    const isLoading = false;
    const [isUploading, setIsUploading] = useState(false);

    function uploadDocument(documents) {
        setIsUploading(true);
        retrocheckService
            .uploadDocument(documents)
            .then(() => {
                getFiles(customerId, filters), setIsUploading(false);
                toast.success("File uploaded successfully.");
            })
            .catch(err => {
                toast.error("Something went wrong while uploading this file.Please try again");
                setIsUploading(false);
            });
    }
    const { filters, setFilters, onFetchData } = useFilters({}, customerId, getFiles, 500, 5);

    return (
        <div>
            <LoadingBar isLoading={isLoading}>
                <Birdseed>
                    <Link to="/" className="link">
                        Home
                    </Link>
                    <a href="javascript:void(0)">Retrocheck</a>
                </Birdseed>
                <DashboardBanner firstName={user.profile.given_name} showStartNewCase={false} />

                <div className="retrocheckUpload">
                    <LoadingBar isLoading={isUploading}>
                        <div className="inline-form">
                            <h2>Retrocheck</h2>
                            <DocumentForm onCancel={() => setIsUploading(false)} onSubmit={uploadDocument} />
                        </div>
                    </LoadingBar>
                </div>
                <div className="filters">
                    <h3>Filters</h3>

                    <RetrocheckFilters submitFilter={setFilters} />
                </div>
                <RetrocheckTable pagedFiles={files} onFetchData={onFetchData} isLoading={files.isLoading} />
            </LoadingBar>
        </div>
    );
};

export const RetrocheckComponentWithUser = withUser(RetrocheckComponent);

export const RetrocheckContainer = connect(
    state => ({
        files: state.retrocheckFiles,
        customerId: state.customer?.data?.customer?.GlobalId,
    }),
    dispatch => ({
        getFiles: (customerId, query, cancellationToken) =>
            dispatch(retrocheckActions.getFiles(customerId, query, cancellationToken)),
        updateRetrocheckFilter: (filter, query) => dispatch(retrocheckActions.updateFileFilter(filter, query)),
    })
)(RetrocheckComponentWithUser);
